// auto-generated by Typewriter template _models.tst from PortCall.Pilots.EndPoints\Api\PilotJobOrder\ApiPilotJobOrderVersion.cs
import S, { DataSignal } from 's-js';
import SArray, { SDataArray } from 's-array';
import TZDate from 'lib/TZDate';
import { jsonableObservable } from 'lib/jsonableObservable';
import { Change, ChangeData, ChangeOptions } from 'data/models/Change';
import { ItineraryPointSelf, ItineraryPointSelfData, ItineraryPointSelfOptions } from 'data/models/ItineraryPointSelf';
import { JobOrderSelf, JobOrderSelfData, JobOrderSelfOptions } from 'data/models/JobOrderSelf';
import { NullableMeasurement, NullableMeasurementData, NullableMeasurementOptions } from 'data/models/Measurement';
import { PilotJobOrderVersion as _PilotJobOrderVersion, PilotJobOrderVersionData as _PilotJobOrderVersionData, PilotJobOrderVersionOptions as _PilotJobOrderVersionOptions } from 'data/models/PilotJobOrderVersion';
import { PortCallSelf, PortCallSelfData, PortCallSelfOptions } from 'data/models/PortCallSelf';
import { QuickBooksJobTracking, QuickBooksJobTrackingData, QuickBooksJobTrackingOptions } from 'data/models/QuickBooksJobTracking';
import { ScheduleDate, ScheduleDateData, ScheduleDateOptions } from 'data/models/ScheduleDate';

// PilotJobOrderVersionData is the class that PilotJobOrderVersion serializes to/from
export interface PilotJobOrderVersionData {
    ChangeId : number;
    Id : number;
	
    Change : ChangeData | null;
    FromPoint : ItineraryPointSelfData | null;
    FromPointId : number;
    LineHandlingCompanyId : number | null;
    NextVersion : _PilotJobOrderVersionData[] | null;
    PilotAgencyId : number;
    PortCall : PortCallSelfData | null;
    PortCallId : number;
    PrevChange : ChangeData | null;
    PrevChangeId : number | null;
    PrevVersion : _PilotJobOrderVersionData | null;
    Self : JobOrderSelfData | null;
    ToPoint : ItineraryPointSelfData | null;
    ToPointId : number;
    TugCompanyId : number | null;
    VesselId : number | null;
	
    AcknowledgedDate : /* ISO8601 */ string | null;
    AirDraft : NullableMeasurementData;
    Billable : boolean;
    BillToAddress : string | null;
    BillToAgent : boolean;
    BowThrusterOperational : boolean | null;
    DeepDraft : NullableMeasurementData;
    DeepDraftConfirmed : boolean;
    Deleted : boolean;
    End : ScheduleDateData;
    ExtraDataJSON : string | null;
    Guid : /* GUID */ string;
    LaborStartTime : /* ISO8601 */ string | null;
    Length : NullableMeasurementData;
    NumberOfTugs : number;
    QBTracking : QuickBooksJobTrackingData;
    Remarks : string | null;
    Start : ScheduleDateData;
    StartTimeConfirmed : boolean;
}

// PilotJobOrderVersionOptions is the class which may be passed to the PilotJobOrderVersion constructor to define optional initial data values
export interface PilotJobOrderVersionOptions {
    ChangeId : number;
    Id : number;
	
    Change? : ChangeOptions | null;
    FromPoint? : ItineraryPointSelfOptions | null;
    FromPointId? : number;
    LineHandlingCompanyId? : number | null;
    NextVersion? : _PilotJobOrderVersionOptions[] | null;
    PilotAgencyId? : number;
    PortCall? : PortCallSelfOptions | null;
    PortCallId? : number;
    PrevChange? : ChangeOptions | null;
    PrevChangeId? : number | null;
    PrevVersion? : _PilotJobOrderVersionOptions | null;
    Self? : JobOrderSelfOptions | null;
    ToPoint? : ItineraryPointSelfOptions | null;
    ToPointId? : number;
    TugCompanyId? : number | null;
    VesselId? : number | null;
	
    AcknowledgedDate? : /* ISO8601 */ string | null;
    AirDraft? : NullableMeasurementOptions;
    Billable? : boolean;
    BillToAddress? : string | null;
    BillToAgent? : boolean;
    BowThrusterOperational? : boolean | null;
    DeepDraft? : NullableMeasurementOptions;
    DeepDraftConfirmed? : boolean;
    Deleted? : boolean;
    End? : ScheduleDateOptions;
    ExtraDataJSON? : string | null;
    Guid? : /* GUID */ string;
    LaborStartTime? : /* ISO8601 */ string | null;
    Length? : NullableMeasurementOptions;
    NumberOfTugs? : number;
    QBTracking? : QuickBooksJobTrackingOptions;
    Remarks? : string | null;
    Start? : ScheduleDateOptions;
    StartTimeConfirmed? : boolean;
}

export class PilotJobOrderVersion {
    public ChangeId : DataSignal<number>;
    public Id : DataSignal<number>;
	
    public Change : DataSignal<Change | null>;
    public FromPoint : DataSignal<ItineraryPointSelf | null>;
    public FromPointId : DataSignal<number>;
    public LineHandlingCompanyId : DataSignal<number | null>;
    public NextVersion : SDataArray<_PilotJobOrderVersion>;
    public PilotAgencyId : DataSignal<number>;
    public PortCall : DataSignal<PortCallSelf | null>;
    public PortCallId : DataSignal<number>;
    public PrevChange : DataSignal<Change | null>;
    public PrevChangeId : DataSignal<number | null>;
    public PrevVersion : DataSignal<_PilotJobOrderVersion | null>;
    public Self : DataSignal<JobOrderSelf | null>;
    public ToPoint : DataSignal<ItineraryPointSelf | null>;
    public ToPointId : DataSignal<number>;
    public TugCompanyId : DataSignal<number | null>;
    public VesselId : DataSignal<number | null>;
	
    public AcknowledgedDate : DataSignal<TZDate | null>;
    public AirDraft : NullableMeasurement;
    public Billable : DataSignal<boolean>;
    public BillToAddress : DataSignal<string | null>;
    public BillToAgent : DataSignal<boolean>;
    public BowThrusterOperational : DataSignal<boolean | null>;
    public DeepDraft : NullableMeasurement;
    public DeepDraftConfirmed : DataSignal<boolean>;
    public Deleted : DataSignal<boolean>;
    public End : ScheduleDate;
    public ExtraDataJSON : DataSignal<string | null>;
    public Guid : DataSignal<string>;
    public LaborStartTime : DataSignal<TZDate | null>;
    public Length : NullableMeasurement;
    public NumberOfTugs : DataSignal<number>;
    public QBTracking : QuickBooksJobTracking;
    public Remarks : DataSignal<string | null>;
    public Start : ScheduleDate;
    public StartTimeConfirmed : DataSignal<boolean>;

    constructor();
    constructor(data : PilotJobOrderVersionOptions);
    constructor(data: PilotJobOrderVersionOptions | null = null) {
        this.ChangeId = jsonableObservable(S.value<number>(data && data.ChangeId !== undefined ? data.ChangeId : 0));
        this.Id = jsonableObservable(S.value<number>(data && data.Id !== undefined ? data.Id : 0));
	    
        this.Change = S.value<Change | null>(null);
        this.FromPoint = S.value<ItineraryPointSelf | null>(null);
        this.FromPointId = jsonableObservable(S.value<number>(data && data.FromPointId !== undefined ? data.FromPointId : 0));
        this.LineHandlingCompanyId = jsonableObservable(S.value<number | null>(data && data.LineHandlingCompanyId !== undefined ? data.LineHandlingCompanyId : null));
        this.NextVersion = SArray<_PilotJobOrderVersion>([]);
        this.PilotAgencyId = jsonableObservable(S.value<number>(data && data.PilotAgencyId !== undefined ? data.PilotAgencyId : 0));
        this.PortCall = S.value<PortCallSelf | null>(null);
        this.PortCallId = jsonableObservable(S.value<number>(data && data.PortCallId !== undefined ? data.PortCallId : 0));
        this.PrevChange = S.value<Change | null>(null);
        this.PrevChangeId = jsonableObservable(S.value<number | null>(data && data.PrevChangeId !== undefined ? data.PrevChangeId : null));
        this.PrevVersion = S.value<_PilotJobOrderVersion | null>(null);
        this.Self = S.value<JobOrderSelf | null>(null);
        this.ToPoint = S.value<ItineraryPointSelf | null>(null);
        this.ToPointId = jsonableObservable(S.value<number>(data && data.ToPointId !== undefined ? data.ToPointId : 0));
        this.TugCompanyId = jsonableObservable(S.value<number | null>(data && data.TugCompanyId !== undefined ? data.TugCompanyId : null));
        this.VesselId = jsonableObservable(S.value<number | null>(data && data.VesselId !== undefined ? data.VesselId : null));
	    
        this.AcknowledgedDate = jsonableObservable(S.value<TZDate | null>(data && data.AcknowledgedDate !== undefined ? data.AcknowledgedDate === null ? null : new TZDate(data.AcknowledgedDate) : null, TZDate.nullableEq));
        this.AirDraft = data && data.AirDraft !== undefined ? new NullableMeasurement(data.AirDraft) : new NullableMeasurement();
        this.Billable = jsonableObservable(S.value<boolean>(data && data.Billable !== undefined ? data.Billable : false));
        this.BillToAddress = jsonableObservable(S.value<string | null>(data && data.BillToAddress !== undefined ? data.BillToAddress : null));
        this.BillToAgent = jsonableObservable(S.value<boolean>(data && data.BillToAgent !== undefined ? data.BillToAgent : false));
        this.BowThrusterOperational = jsonableObservable(S.value<boolean | null>(data && data.BowThrusterOperational !== undefined ? data.BowThrusterOperational : null));
        this.DeepDraft = data && data.DeepDraft !== undefined ? new NullableMeasurement(data.DeepDraft) : new NullableMeasurement();
        this.DeepDraftConfirmed = jsonableObservable(S.value<boolean>(data && data.DeepDraftConfirmed !== undefined ? data.DeepDraftConfirmed : false));
        this.Deleted = jsonableObservable(S.value<boolean>(data && data.Deleted !== undefined ? data.Deleted : false));
        this.End = data && data.End !== undefined ? new ScheduleDate(data.End) : new ScheduleDate();
        this.ExtraDataJSON = jsonableObservable(S.value<string | null>(data && data.ExtraDataJSON !== undefined ? data.ExtraDataJSON : null));
        this.Guid = jsonableObservable(S.value<string>(data && data.Guid !== undefined ? data.Guid : '00000000-0000-0000-0000-000000000000'));
        this.LaborStartTime = jsonableObservable(S.value<TZDate | null>(data && data.LaborStartTime !== undefined ? data.LaborStartTime === null ? null : new TZDate(data.LaborStartTime) : null, TZDate.nullableEq));
        this.Length = data && data.Length !== undefined ? new NullableMeasurement(data.Length) : new NullableMeasurement();
        this.NumberOfTugs = jsonableObservable(S.value<number>(data && data.NumberOfTugs !== undefined ? data.NumberOfTugs : 0));
        this.QBTracking = data && data.QBTracking !== undefined ? new QuickBooksJobTracking(data.QBTracking) : new QuickBooksJobTracking();
        this.Remarks = jsonableObservable(S.value<string | null>(data && data.Remarks !== undefined ? data.Remarks : null));
        this.Start = data && data.Start !== undefined ? new ScheduleDate(data.Start) : new ScheduleDate();
        this.StartTimeConfirmed = jsonableObservable(S.value<boolean>(data && data.StartTimeConfirmed !== undefined ? data.StartTimeConfirmed : false));
    }

    static key(obj : PilotJobOrderVersion) {
        return obj.ChangeId() + '\u2618' + obj.Id();
    }
    
    static dataKey(obj : PilotJobOrderVersionOptions) {
        return obj.ChangeId + '\u2618' + obj.Id;
    }

    static update(obj : PilotJobOrderVersion, data : PilotJobOrderVersionOptions) {
        S.freeze(() => {
            if (data.ChangeId !== undefined) obj.ChangeId(data.ChangeId);
            if (data.Id !== undefined) obj.Id(data.Id);
	        
            if (data.FromPointId !== undefined) obj.FromPointId(data.FromPointId);
            if (data.LineHandlingCompanyId !== undefined) obj.LineHandlingCompanyId(data.LineHandlingCompanyId);
            if (data.PilotAgencyId !== undefined) obj.PilotAgencyId(data.PilotAgencyId);
            if (data.PortCallId !== undefined) obj.PortCallId(data.PortCallId);
            if (data.PrevChangeId !== undefined) obj.PrevChangeId(data.PrevChangeId);
            if (data.ToPointId !== undefined) obj.ToPointId(data.ToPointId);
            if (data.TugCompanyId !== undefined) obj.TugCompanyId(data.TugCompanyId);
            if (data.VesselId !== undefined) obj.VesselId(data.VesselId);
	        
            if (data.AcknowledgedDate !== undefined) obj.AcknowledgedDate(data.AcknowledgedDate === null ? null : new TZDate(data.AcknowledgedDate));
            if (data.AirDraft !== undefined) NullableMeasurement.update(obj.AirDraft, data.AirDraft);
            if (data.Billable !== undefined) obj.Billable(data.Billable);
            if (data.BillToAddress !== undefined) obj.BillToAddress(data.BillToAddress);
            if (data.BillToAgent !== undefined) obj.BillToAgent(data.BillToAgent);
            if (data.BowThrusterOperational !== undefined) obj.BowThrusterOperational(data.BowThrusterOperational);
            if (data.DeepDraft !== undefined) NullableMeasurement.update(obj.DeepDraft, data.DeepDraft);
            if (data.DeepDraftConfirmed !== undefined) obj.DeepDraftConfirmed(data.DeepDraftConfirmed);
            if (data.Deleted !== undefined) obj.Deleted(data.Deleted);
            if (data.End !== undefined) ScheduleDate.update(obj.End, data.End);
            if (data.ExtraDataJSON !== undefined) obj.ExtraDataJSON(data.ExtraDataJSON);
            if (data.Guid !== undefined) obj.Guid(data.Guid);
            if (data.LaborStartTime !== undefined) obj.LaborStartTime(data.LaborStartTime === null ? null : new TZDate(data.LaborStartTime));
            if (data.Length !== undefined) NullableMeasurement.update(obj.Length, data.Length);
            if (data.NumberOfTugs !== undefined) obj.NumberOfTugs(data.NumberOfTugs);
            if (data.QBTracking !== undefined) QuickBooksJobTracking.update(obj.QBTracking, data.QBTracking);
            if (data.Remarks !== undefined) obj.Remarks(data.Remarks);
            if (data.Start !== undefined) ScheduleDate.update(obj.Start, data.Start);
            if (data.StartTimeConfirmed !== undefined) obj.StartTimeConfirmed(data.StartTimeConfirmed);
        });
    }
}



// WEBPACK FOOTER //
// ./server/models/PilotJobOrderVersion.ts